<form [formGroup]="form" (ngSubmit)="submit()" class="fadeInDown">
  <h2 class="form-header">{{ formHeader() }}</h2>

  @if (!isTwoFactorStep) {
    <div class="form-group fadeIn">
      <app-input appearance="auth-login-form" type="text"
        placeholder="{{ 'login-form.email' | translate }}"
        formControlName="username"
        inputIcon="icon-user"
        [class.is-invalid]="login && loginFormControls['username'].errors"
       />
      @if (loginFormControls['username'].errors || (login && loginFormControls['username'].errors)) {
        <div class="invalid-feedback">
          @if (loginFormControls['username'].errors['required']) {
            <div translate>form.required</div>
          }
        </div>
      }
    </div>
    <div class="form-group login-password-container fadeIn">
      <app-input appearance="auth-login-form" type="password"
        placeholder="{{ 'login-form.password' | translate }}"
        formControlName="password"
        inputIcon="icon-password"
        [class.is-invalid]="login && loginFormControls['password'].errors"
       />
      @if (loginFormControls['password'].errors || (login && loginFormControls['password'].errors)) {
        <div class="invalid-feedback">
          @if (loginFormControls['password'].errors['required']) {
            <div translate>form.required</div>
          }
        </div>
      }
      <div class="password-recover-link"><a routerLink="/auth/password-recover" translate>login.form.remind</a></div>
    </div>
    <div class="form-group login-submit fadeIn">
      @if (!isElectron) {
        <app-input-checkbox
          formControlName="isRememberMe"
          >{{ 'login.form.remember' | translate }}</app-input-checkbox
        >
      }
      <app-button variant="dark" size="lg"
        type="submit"
        [disabled]="loginLoading"
        >{{ 'login.form.button' | translate }}</app-button
      >
    </div>
    @if (showResentInvitation) {
      <app-button variant="dark" size="lg"
        type="button"
        (click)="resentInvitation($event)"
        >{{ 'login.form.resentInvitation' | translate }}</app-button
      >
    }
    @if (form.errors) {
      <div class="errors">
        {{ showErrors() }}
      </div>
    }
  }

  @if (isTwoFactorStep) {
    <div class="two-factor fadeIn" [formGroup]="twoFactorForm">
      <div class="two-factor__title">
        {{ twoFactorTitleKey | translate }}
      </div>
      <div class="two-factor__description">
        {{ twoFactorDescriptionKey | translate }}
      </div>

      <div class="form-group fadeIn">
        <app-input appearance="auth-login-form" type="text"
          placeholder="{{ 'login.two_factor.code_placeholder' | translate }}"
          formControlName="code"
          inputIcon="icon-password"
          [cleanSpecialCharacters]="twoFactorCodeCleaner"
          [class.is-invalid]="twoFactorSubmitted && twoFactorFormControls['code'].errors"
         />
        @if (twoFactorSubmitted && twoFactorFormControls['code'].errors) {
          <div class="invalid-feedback">
            <div>{{ twoFactorCodeErrorKey | translate }}</div>
          </div>
        }
      </div>

      <app-button variant="dark" size="lg"
        type="submit"
        [disabled]="twoFactorLoading"
        >{{ 'login.two_factor.verify_button' | translate }}</app-button
      >

      <div class="two-factor__links">
        @if (!isEmailProvider) {
          <a href="#" (click)="useEmailCode($event)">
            {{ 'login.two_factor.verify_by_email' | translate }}
          </a>
        }
        @if (!isAuthenticatorProvider) {
          <a href="#" (click)="useAuthenticatorCode($event)">
            {{ 'login.two_factor.verify_by_authenticator' | translate }}
          </a>
        }
        @if (!isBackupCodeProvider) {
          <a href="#" (click)="useBackupCode($event)">
            {{ 'login.two_factor.verify_by_backup_code' | translate }}
          </a>
        }
        <a href="#" (click)="backToCredentials($event)">
          {{ 'login.two_factor.back_to_login' | translate }}
        </a>
      </div>

      @if (twoFactorForm.errors) {
        <div class="errors">
          {{ showTwoFactorErrors() }}
        </div>
      }
    </div>
  }
</form>
